import { render, staticRenderFns } from "./CreditNotAvailable.vue?vue&type=template&id=4c952190&scoped=true"
import script from "./CreditNotAvailable.vue?vue&type=script&lang=js"
export * from "./CreditNotAvailable.vue?vue&type=script&lang=js"
import style0 from "./CreditNotAvailable.vue?vue&type=style&index=0&id=4c952190&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c952190",
  null
  
)

export default component.exports